import { defineStore } from "pinia";
import { ref } from "vue";

import { createBroadcastChannel } from "@polargold/pg-frontend-core";

export const UPDATE_CHANNEL_NAME = "autoq-update-available";

type UpdateChannelMessage = "update-available" | "reload";

export const useAppVersionStore = defineStore("appVersion", () => {
    const loadedVersion = ref<string>();
    const updateAvailable = ref<boolean>(false);

    const updateChannel = createBroadcastChannel(UPDATE_CHANNEL_NAME);

    const setLoadedVersion = (version: string) => {
        loadedVersion.value = version;
    };

    // Called once this tab detects a new version itself; tells every other open tab to
    // show the banner too, instead of waiting for their own poll/focus check.
    const flagUpdateAvailable = () => {
        updateAvailable.value = true;
        updateChannel?.postMessage("update-available" as UpdateChannelMessage);
    };

    // Called when the user clicks "Update now". Reloads this tab and tells every other
    // open tab to reload too, so no tab is left showing a banner for an update it
    // never actually applied.
    const applyUpdate = () => {
        updateChannel?.postMessage("reload" as UpdateChannelMessage);
        window.location.reload();
    };

    const handleChannelMessage = (event: MessageEvent<UpdateChannelMessage>) => {
        if (event.data === "reload") {
            window.location.reload();

            return;
        }

        updateAvailable.value = true;
    };

    updateChannel?.addEventListener("message", handleChannelMessage);

    const dispose = () => {
        updateChannel?.removeEventListener("message", handleChannelMessage);
        updateChannel?.close();
    };

    return {
        loadedVersion,
        updateAvailable,
        setLoadedVersion,
        flagUpdateAvailable,
        applyUpdate,
        dispose
    };
});
